webpackJsonp([1],Array(28).concat([
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(146),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_postsListing__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_postsListing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_postsListing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_postPage__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_postPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_postPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_pageNotFound__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_pageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_pageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_homePage__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_homePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_homePage__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// Define routes
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history', /* Removes hash from URL */
	routes: [{
		path: '/',
		name: 'Index',
		component: __WEBPACK_IMPORTED_MODULE_5__pages_homePage___default.a
	}, {
		path: '/post/:slug',
		name: 'Post',
		component: __WEBPACK_IMPORTED_MODULE_3__pages_postPage___default.a
	}, {
		path: '/404',
		alias: '*',
		name: 'pageNotFound',
		component: __WEBPACK_IMPORTED_MODULE_4__pages_pageNotFound___default.a
	}]
});

// On page transition, reset vertical scroll
router.beforeEach(function (to, from, next) {
	window.scrollTo(0, 0);
	next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(149);





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
	state: {
		authors: null,
		posts: null
	},
	actions: {
		getAuthors: function getAuthors(context) {
			// Grab authors
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://nport.vincentsnaggdesign.com/wp-json/wp/v2/users').then(function (response) {
				context.commit('storeAuthors', response.data);
			});
		},
		getPosts: function getPosts(context) {
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (context.state.posts) {
					resolve();
				} else {
					// Grab posts from WP-API
					__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://nport.vincentsnaggdesign.com/wp-json/wp/v2/posts?_embed').then(function (response) {
						context.commit('storePosts', response.data);
						resolve();
					}).catch(function (error) {
						reject(error);
					});
				}
			});
		}
	},
	mutations: {
		storeAuthors: function storeAuthors(state, response) {
			state.authors = response;
		},
		storePosts: function storePosts(state, response) {
			state.posts = response;
		}
	}

});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(140),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(52);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_header_app_header__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_header_app_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_app_header_app_header__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {
		appHeader: __WEBPACK_IMPORTED_MODULE_0__components_app_header_app_header___default.a
	},
	created: function created() {
		this.$store.dispatch('getAuthors');
		this.$store.dispatch('getPosts');
	}
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'button'
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_logo_logo__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_logo_logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_logo_logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navigation_navigation__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navigation_navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_navigation_navigation__);
//
//
//
//
//
//
//
//

// Import components



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app-header',
	components: {
		logo: __WEBPACK_IMPORTED_MODULE_0__components_logo_logo___default.a,
		navigation: __WEBPACK_IMPORTED_MODULE_1__components_navigation_navigation___default.a
	}
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'icon',
	props: ['use']
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'logo'
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'navigation',
	data: function data() {
		return {
			links: [{
				name: 'Posts',
				path: '/'
			}, {
				name: 'Vue',
				path: 'https://vuejs.org'
			}, {
				name: 'WP API',
				path: 'https://developer.wordpress.org/rest-api/'
			}, {
				name: 'Twitter',
				path: 'http://www.twitter.com/webdevluke'
			}]
		};
	},

	methods: {
		// Returns true if path contains "http", used to figure out if we're dealing with an external link
		externalPath: function externalPath(link) {
			return link.path.indexOf('http') === -1;
		}
	}
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_button_app_button__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_button_app_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_app_button_app_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_icons__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_icons_icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_clock_svg__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_user_svg__ = __webpack_require__(124);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Import components



// Import SVG icons



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'post',
	props: {
		title: {
			type: String
		},
		author: {
			type: String
		},
		date: {
			type: String
		},
		preview: {
			type: String
		},
		content: {
			type: String
		},
		slug: {
			type: String
		},
		previewImage: {
			type: String
		},
		fullImage: {
			type: String
		}
	},
	components: {
		icon: __WEBPACK_IMPORTED_MODULE_1__components_icons_icons___default.a,
		appButton: __WEBPACK_IMPORTED_MODULE_0__components_app_button_app_button___default.a
	},
	data: function data() {
		return {
			clock: __WEBPACK_IMPORTED_MODULE_2__assets_img_clock_svg__["a" /* default */],
			user: __WEBPACK_IMPORTED_MODULE_3__assets_img_user_svg__["a" /* default */]
		};
	},

	computed: {
		// Returns true if post should display as preview
		isPreview: function isPreview() {
			if (this.preview && this.previewImage) {
				return true;
			}
			return false;
		}
	}
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_icons__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_icons_icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_post_post__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_post_post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_post_post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_loading_svg__ = __webpack_require__(123);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Import components



// Import SVG icons


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'posts',
	props: {
		type: {
			type: String,
			required: true
		}
	},
	components: {
		icon: __WEBPACK_IMPORTED_MODULE_1__components_icons_icons___default.a,
		post: __WEBPACK_IMPORTED_MODULE_2__components_post_post___default.a
	},
	data: function data() {
		return {
			singlePost: null
		};
	},
	created: function created() {
		var _this = this;

		if (this.type === 'single') {
			// If we're viewing component in single post mode, grab the post and if not found send to 404 page
			this.getSinglePost().then(null, function () {
				_this.$router.push({ name: 'pageNotFound' });
			});
		}
	},

	methods: {
		// Formats date into presentable format
		formatDate: function formatDate(date) {
			var dateObj = new Date(date);
			var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
			return dateObj.getDate() + ' ' + monthNames[dateObj.getMonth()] + ' ' + dateObj.getFullYear();
		},
		getSinglePost: function getSinglePost() {
			var _this2 = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this2.$store.dispatch('getPosts').then(function () {
					var foundPost = false;
					_this2.$store.state.posts.filter(function (post) {
						if (post.slug === _this2.$route.params.slug) {
							_this2.singlePost = post;
							foundPost = true;
						}
					});
					foundPost ? resolve() : reject();
				});
			});
		},
		// Returns user name when passed ID
		getUserName: function getUserName(userId) {
			var username = 'unknown';
			this.$store.state.authors.filter(function (user) {
				if (user.id === userId) {
					username = user.name;
				}
			});
			return username;
		}
	}
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_posts_posts__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_posts_posts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_posts_posts__);
//
//
//
//
//
//
//

// Import components


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'posts-listing',
	components: {
		posts: __WEBPACK_IMPORTED_MODULE_0__components_posts_posts___default.a
	}
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'pageNotFound'
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_posts_posts__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_posts_posts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_posts_posts__);
//
//
//
//
//
//

// Import components


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'posts-page',
	components: {
		posts: __WEBPACK_IMPORTED_MODULE_0__components_posts_posts___default.a
	}
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_posts_posts__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_posts_posts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_posts_posts__);
//
//
//
//
//
//

// Import components


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'posts-listing',
	components: {
		posts: __WEBPACK_IMPORTED_MODULE_0__components_posts_posts___default.a
	}
});

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "clock",
  "use": "clock-usage",
  "viewBox": "0 0 97.16 97.16",
  "content": "<symbol viewBox=\"0 0 97.16 97.16\" id=\"clock\">\r\n\t\t<path d=\"M48.58,0C21.793,0,0,21.793,0,48.58s21.793,48.58,48.58,48.58s48.58-21.793,48.58-48.58S75.367,0,48.58,0z M48.58,86.823\r\n\t\t\tc-21.087,0-38.244-17.155-38.244-38.243S27.493,10.337,48.58,10.337S86.824,27.492,86.824,48.58S69.667,86.823,48.58,86.823z\" />\r\n\t\t<path d=\"M73.898,47.08H52.066V20.83c0-2.209-1.791-4-4-4c-2.209,0-4,1.791-4,4v30.25c0,2.209,1.791,4,4,4h25.832\r\n\t\t\tc2.209,0,4-1.791,4-4S76.107,47.08,73.898,47.08z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "loading",
  "use": "loading-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" id=\"loading\"><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"translate(0 -30)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(30 105.98 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.08333333333333333s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(60 75.98 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.16666666666666666s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(90 65 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.25s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(120 58.66 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.3333333333333333s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(150 54.02 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.4166666666666667s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(180 50 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.5s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(-150 45.98 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.5833333333333334s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(-120 41.34 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.6666666666666666s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(-90 35 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.75s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(-60 24.02 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.8333333333333334s\" repeatCount=\"indefinite\"></animate></rect><rect class=\"icon-loading-elem\" x=\"46.5\" y=\"40\" width=\"7\" height=\"20\" rx=\"5\" ry=\"5\" transform=\"rotate(-30 -5.98 65)\"><animate attributeName=\"opacity\" from=\"1\" to=\"0\" dur=\"1s\" begin=\"0.9166666666666666s\" repeatCount=\"indefinite\"></animate></rect></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* unused harmony default export */ var _unused_webpack_default_export = (symbol);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 77.9 80.1",
  "content": "<symbol viewBox=\"0 0 77.9 80.1\" id=\"user\">\n\t<path d=\"M39,50.1c6.2,0,11.5-2.4,15.8-7.3c4.4-4.9,6.6-10.8,6.6-17.7c0-6.9-2.2-12.8-6.6-17.7C50.4,2.4,45.2,0,39,0\n\t\tS27.5,2.4,23.1,7.3c-4.4,4.9-6.6,10.8-6.6,17.7c0,6.9,2.2,12.8,6.6,17.7C27.5,47.6,32.8,50.1,39,50.1L39,50.1z M39,50.1\" />\n\t<path d=\"M77.4,62.3C76.8,60.1,76,58,74.9,56c-1-2.1-2.3-3.8-3.6-5.3c-1.4-1.5-3-2.6-5-3.5c-2-0.9-4.1-1.3-6.5-1.3\n\t\tc-0.3,0-1.2,0.5-2.4,1.4c-1.3,0.9-2.7,2-4.3,3.1c-1.6,1.2-3.7,2.2-6.3,3.1c-2.6,0.9-5.2,1.4-7.8,1.4c-2.6,0-5.2-0.5-7.8-1.4\n\t\tc-2.6-0.9-4.7-2-6.3-3.1c-1.6-1.1-3.1-2.2-4.3-3.1c-1.3-0.9-2.1-1.4-2.4-1.4c-2.4,0-4.5,0.4-6.5,1.3c-2,0.9-3.6,2-5,3.5\n\t\tC5.3,52.1,4,53.9,3,56c-1.1,2.1-1.9,4.2-2.5,6.4c-0.6,2.2-1.1,10.3,1.7,13.3c2.8,3,6.6,4.5,11.3,4.5h51c4.7,0,8.5-1.5,11.3-4.5\n\t\tC78.6,72.6,78.1,64.5,77.4,62.3z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(136),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(142),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(139),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(137),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(145),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(143),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "c-button"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-layout o-layout--spacing-large"
  }, [_c('section', {
    staticClass: "o-layout__item u-align-center"
  }, [_c('h1', {
    staticClass: "c-type-alpha u-bold u-type-pink"
  }, [_vm._v("Page not found")]), _vm._v(" "), _c('p', [_vm._v("Sorry, this page doesn't exist.")])])])
}]}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "c-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "c-logo__wrapper"
  }, [_c('span', {
    staticClass: "c-type-delta "
  }, [_vm._v("My")]), _vm._v(" "), _c('span', {
    staticClass: "c-type-delta c-logo__rad"
  }, [_vm._v("Rad")]), _vm._v(" "), _c('span', {
    staticClass: "c-type-delta"
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('span', {
    staticClass: "c-type-echo c-logo__tagline"
  }, [_c('span', {
    staticClass: "c-logo__tagline-text"
  }, [_vm._v("- Powered by VueJS & Wordpress API -")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "u-flex"
  }, [_c('h2', [_vm._v("This is the homepage")]), _vm._v(" "), _c('posts', {
    attrs: {
      "type": "list"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-flex",
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "o-container u-flex u-flex-width"
  }, [_c('div', {
    staticClass: "o-layout o-layout--spacing-large u-flex"
  }, [_c('div', {
    staticClass: "o-box o-box--spacing-regular o-layout__item u-10/12 u-offset-1/12 u-background-white u-flex"
  }, [_c('transition', {
    attrs: {
      "name": "change",
      "enter-active-class": "anim-enter",
      "leave-active-class": "anim-out",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.use
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isPreview) ? _c('div', {
    staticClass: "o-media o-media--spacing-regular o-media--top c-post u-margin-bottom-regular"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('router-link', {
    attrs: {
      "to": '/post/' + _vm.slug
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.previewImage,
      "alt": _vm.title
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body u-nudge-bottom-tiny"
  }, [_c('div', {
    staticClass: "c-post__title"
  }, [_c('h2', {
    staticClass: "c-type-charlie"
  }, [_c('router-link', {
    attrs: {
      "to": '/post/' + _vm.slug
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-post__info u-margin-bottom-small"
  }, [_c('div', {
    staticClass: "o-media o-media--spacing-micro u-margin-right-small"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('icon', {
    staticClass: "c-icon-user",
    attrs: {
      "use": "user"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._v("\n\t\t\t\t\t\tBy " + _vm._s(_vm.author) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "o-media o-media--spacing-micro"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('icon', {
    staticClass: "c-icon-clock",
    attrs: {
      "use": "clock"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.date) + "\n\t\t\t\t\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.preview)
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/post/' + _vm.slug
    }
  }, [_c('app-button', [_vm._v("Read more")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isPreview) ? _c('article', [_c('div', {
    staticClass: "c-post__header u-margin-bottom-reduced"
  }, [_c('div', {
    staticClass: "c-post__header-text"
  }, [_c('h2', {
    staticClass: "c-type-alpha"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "c-post__header-text-info"
  }, [_c('div', {
    staticClass: "o-media o-media--spacing-micro u-margin-right-small"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('icon', {
    staticClass: "c-icon-user",
    attrs: {
      "use": "user"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._v("\n\t\t\t\t\t\t\tBy " + _vm._s(_vm.author) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "o-media o-media--spacing-micro"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('icon', {
    staticClass: "c-icon-clock",
    attrs: {
      "use": "clock"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.date) + "\n\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('img', {
    staticClass: "u-full-width",
    attrs: {
      "src": _vm.fullImage,
      "alt": _vm.title
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "u-flex"
  }, [_c('posts', {
    attrs: {
      "type": "list"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "o-container c-navigation"
  }, [_c('div', {
    staticClass: "o-layout o-layout--spacing-large"
  }, [_c('div', {
    staticClass: "o-layout__item u-10/12 u-offset-1/12 u-background-purple"
  }, [_c('div', {
    staticClass: "o-box o-box--spacing-small u-padding-horzontal-none u-type-white"
  }, [_c('ul', {
    staticClass: "o-list-inline o-list-inline--spacing-reduced o-list-inline--delimited-pipe"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      staticClass: "o-list-inline__item c-type-beta"
    }, [(_vm.externalPath(link)) ? _c('router-link', {
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.name))]) : _c('a', {
      attrs: {
        "href": link.path
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  }))])])])])
},staticRenderFns: []}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "u-flex"
  }, [_c('posts', {
    attrs: {
      "type": "single"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-flex"
  }, [(!this.$store.state.posts) ? _c('div', {
    staticClass: "u-align-center"
  }, [_c('icon', {
    staticClass: "c-icon-loading",
    attrs: {
      "use": "loading"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$store.state.posts) ? _c('div', [(this.type === 'list') ? _c('div', _vm._l((this.$store.state.posts), function(post) {
    return _c('post', {
      key: post.slug,
      attrs: {
        "title": post.title.rendered,
        "author": _vm.getUserName(post.author),
        "date": _vm.formatDate(post.date),
        "preview": post.excerpt.rendered,
        "slug": post.slug,
        "previewImage": post._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url
      }
    })
  })) : _vm._e(), _vm._v(" "), (this.type === 'single') ? _c('div', [(_vm.singlePost) ? _c('post', {
    attrs: {
      "title": _vm.singlePost.title.rendered,
      "author": _vm.getUserName(_vm.singlePost.author),
      "date": _vm.formatDate(_vm.singlePost.date),
      "content": _vm.singlePost.content.rendered,
      "slug": _vm.singlePost.slug,
      "fullImage": _vm.singlePost._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ })
]),[72]);


// WEBPACK FOOTER //
// static/js/app.b61846632c7ef747094c.js